import { FC, PropsWithChildren, createContext, memo, useContext } from 'react';

const tokenContext = createContext<string | undefined>(undefined);

type Props = {
  token: string | undefined;
};

export const CsrfTokenProvider: FC<PropsWithChildren<Props>> = memo(
  ({ children, token }) => {
    return (
      <tokenContext.Provider value={token}>{children}</tokenContext.Provider>
    );
  }
);
CsrfTokenProvider.displayName = 'CsrfTokenProvider';

export const useCsrfToken = () => useContext(tokenContext);
